import type { Rgb } from "./orb-colors";
import { rgbToHex } from "./orb-colors";

/**
 * Bentuk orb versi diam, sebagai SVG.
 *
 * Dipakai di tiga keadaan nyata, bukan hanya sebagai jaring pengaman:
 * saat OS/aplikasi meminta gerak dikurangi, saat kanvas 2D tidak tersedia
 * (browser yang memblokir kanvas, lingkungan test happy-dom), dan sebagai
 * tampilan pertama sebelum frame kanvas pertama digambar.
 */
export function OrbStatic({
	name,
	size,
	from,
	to,
	gradientId,
}: {
	/** Dibaca pembaca layar sebagai nama asisten. */
	name: string;
	size: number | "100%";
	from: Rgb;
	to: Rgb;
	/** Harus unik per instance; dua <defs> dengan id sama saling menimpa. */
	gradientId: string;
}) {
	return (
		<svg
			viewBox="0 0 100 100"
			width={size}
			height={size}
			role="img"
			aria-label={name}
			data-assistant-orb="static"
			style={{ display: "block", flexShrink: 0 }}
		>
			<title>{name}</title>
			<defs>
				<linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
					<stop offset="0%" stopColor={rgbToHex(from)} />
					<stop offset="100%" stopColor={rgbToHex(to)} />
				</linearGradient>
			</defs>
			<circle
				cx="50"
				cy="50"
				r="30"
				fill={rgbToHex(from)}
				opacity="0.35"
				aria-hidden
			/>
			<circle
				cx="50"
				cy="50"
				r="34"
				fill="none"
				stroke={`url(#${gradientId})`}
				strokeWidth="8"
				aria-hidden
			/>
		</svg>
	);
}
